import React from 'react';
import {Link} from 'react-router-dom';

const Button =({to})=>{
    return(
        <Link to={to} className="car-attr">
            <div className="car-btn">
                <h2>عن المركز</h2>
            </div>
        </Link>
    );
}

const CarouselItem =({title,semiTitle,className,startClass
      ,endClass,src,hasButton,stateClass,selected})=>{
    return(
        <div className={`${className} text-container `}>
            <img src={src} alt=""/>
            <div className="slider-text">
                <div className={`flex-text ${startClass}`}>
                {!hasButton?[<h1>{title}</h1>,<p>{semiTitle}</p>]:<Button to="about"/>}
                </div>
            </div>
        </div>
    );
}
export default CarouselItem;


// WEBPACK FOOTER //
// ./src/components/home/CarouselItem.js